<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'В работе',
                        url: '/orders',
                    },
                    {
                        title: 'Завершенные',
                        url: '/orders/completed',
                    },
                ],
            };
        },
    };
</script>
